export const TRACK_EVENT_MESSAGE = 'e:tracker:trackEvent';
